import React, { memo } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import SidebarLink from '../../../../common/ui/sidebar-link/index.tsx';
import { messages } from './messages.tsx';

const TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.view-all-projects';

type Props = {
	label?: string;
};

const ViewAllProjects = ({ label }: Props) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<SidebarLink
			href="/jira/projects?selectedProjectType=business"
			testId={TEST_ID}
			onClick={() =>
				fireUIAnalytics(createAnalyticsEvent({}), 'link clicked', 'jwmViewAllProjectsLink')
			}
		>
			<Box as="span" xcss={textStyle}>
				{label ?? formatMessage(messages.viewAllProjectsLabel)}
			</Box>
		</SidebarLink>
	);
};

export default memo(ViewAllProjects);

const textStyle = xcss({
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	fontWeight: token('font.weight.regular'),
});
